import { LinearProgress } from '@mui/material';
import { withRouter } from 'components/shell/WithRouter';
import { getContentStorageUrl } from 'helpers';
import { audioFileUrl, audioJournalArticle, canListen } from 'helpers/audioJournal';
import React, { Suspense, useMemo } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { isPrivileged } from 'store/data/publications/audioSelectors';
import { ApplicationState, ContentType } from 'types';
import DialogPage from './DialogPage';
import HomePage from './HomePage';
const PDFViewerApp = React.lazy<any>(() => import('components/pdf/PDFViewer'));

function PublicationPage({ publications, editions, isModal, privileged }) {
	let { id } = useParams();

	// However the issue was opened: its audio journal (if any) can be played from the reader, with
	// read-along highlighting when it has a read-along map.
	let found = id ? editions.byId[id] : undefined;
	let foundPublication = found ? publications.byId[found.publicationId] : undefined;
	let readAlong = useMemo(() => {
		if (!found || !canListen(found, privileged)) {
			return undefined;
		}
		let cover = getContentStorageUrl(ContentType.Edition, 'cover', found);
		let sync = found.audio.sync;
		return { article: audioJournalArticle(found, foundPublication, cover), syncUrl: sync ? audioFileUrl(found.audio, sync.file) : undefined };
	}, [found, foundPublication, privileged]);

	if (!id || !editions.byId[id]) {
		return <HomePage />;
	}

	let edition = editions.byId[id!];
	let publication = publications.byId[edition.publicationId];

	let pdfUrl: string = getContentStorageUrl(ContentType.Edition, 'file', edition);
	let title = publication.title;

	return (
		<DialogPage disableBackdropClick title={title} dark>
			<Suspense fallback={<LinearProgress />}>
				<PDFViewerApp pdfUrl={pdfUrl} readAlong={readAlong} />
			</Suspense>
		</DialogPage>
	);
}

function mapStateToProps(state: ApplicationState) {
	let editions = state.dataState.editions;
	let publications = state.dataState.publications;

	return {
		editions,
		publications,
		privileged: isPrivileged(state),
	};
}

export default connect(mapStateToProps)(withRouter(PublicationPage));
